import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBtn,{class:_vm.customClasses(),attrs:{"color":_vm.customOrDefaultColor(),"large":"","block":"","depressed":""},on:{"click":_vm.add}},[_vm._v(" ADICIONAR ")])}
var staticRenderFns = []

export { render, staticRenderFns }